<template>
  <v-carousel
    v-if="enabledOffers > 0"
    cycle
    height="200"
    hide-delimiter-background
    show-arrows-on-hover data-qa="offers-carousel-35annhn">
    <v-flex
      v-for="(item,i) in offers"
      :key="i"
      :data-qa="`offers-flex-a3iu3s-${i}`">
      <v-carousel-item
        v-if="item.enable"
        :src="customThemeEnabled ? `${appBaseUrl}assets/custom/offers/${item.src}` : require(`@/assets/offers/${item.src}`)"
        class="offerImages"
        :data-qa="`offers-carousel-item-5daegk-${i}`">
        <v-row align="center" justify="center" class="mt-4" v-if="item.label" :data-qa="`offers-row-o881cu-${i}`">
          <div :class="[item.isImageDark ? 'headline font-weight-bold white--text' : 'headline font-weight-bold black--text']" :data-qa="`offers-div-urjn1v-${i}`">{{item.label}}</div>
        </v-row>
        <v-row align="center" justify="center" v-if="item.desc" :data-qa="`offers-row-mm9i3h-${i}`">
          <v-flex xs12 sm12 md12 lg12 xl12 :data-qa="`offers-flex-johzg-${i}`">
            <p :class="[item.isImageDark ? 'text-center mt-1 ma-0 px-2 subtitle-1 white--text' : 'text-center mt-1 ma-0 px-4 subtitle-1 black--text']" :data-qa="`offers-p-yf9mx-${i}`">{{$t(`offers.${item.desc}`)}}</p>
          </v-flex>
        </v-row>
        <v-row class="mt-2 ml-1" align="center" justify="center" v-if="item.enableButton" :data-qa="`offers-row-twb7ya-${i}`">
          <v-btn
            :color="primaryColor"
            class="white--text text-capitalize py-2 px-4"
            @click="goToOffer(item)"
            :data-qa="`goToOffer-${i}`"

          >{{ $t(`offers.${item.buttonLabel}`) }}</v-btn>
        </v-row>
      </v-carousel-item>
    </v-flex>
  </v-carousel>
</template>
<script>
import '@/styles/pages/home/offers.scss'

export default {
  name: 'Offers',
  components: {},
  data () {
    return {
      offers: this.$appSettings.offerAdvertisementBanners, // this.$offerConfig,
      enabledOffers: 0
    }
  },
  methods: {
    goToOffer (item) {
      switch (item.type) {
        case 'SVGS':
          this.$router.push('/savingsProducts')
          break
        case 'CACC':
          this.$router.push('/currentProducts')
          break
        default: this.$router.push('/depositsProducts')
      }
    }
  },
  created () {
    for (const item of this.offers) {
      item.enable && this.enabledOffers++
    }
  }
}
</script>
